var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionEnd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#DAE4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1499 26.5V28.6",
    stroke: "#141738",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1499 32H27.1499V31C27.1499 29.9 26.2499 29 25.1499 29H19.1499C18.0499 29 17.1499 29.9 17.1499 31V32V32Z",
    stroke: "#141738",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1499 32H28.1499",
    stroke: "#141738",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26C18.13 26 15 22.87 15 19V16C15 13.79 16.79 12 19 12H25C27.21 12 29 13.79 29 16V19C29 22.87 25.87 26 22 26Z",
    stroke: "#141738",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.47 21.6496C14.72 21.4096 14.06 20.9696 13.54 20.4496C12.64 19.4496 12.04 18.2496 12.04 16.8496C12.04 15.4496 13.14 14.3496 14.54 14.3496H15.19C14.99 14.8096 14.89 15.3196 14.89 15.8496V18.8496C14.89 19.8496 15.1 20.7896 15.47 21.6496Z",
    stroke: "#141738",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5298 21.6496C29.2798 21.4096 29.9398 20.9696 30.4598 20.4496C31.3598 19.4496 31.9598 18.2496 31.9598 16.8496C31.9598 15.4496 30.8598 14.3496 29.4598 14.3496H28.8098C29.0098 14.8096 29.1098 15.3196 29.1098 15.8496V18.8496C29.1098 19.8496 28.8998 20.7896 28.5298 21.6496Z",
    stroke: "#141738",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionEnd);
export default __webpack_public_path__ + "static/media/action-end.807e920efb2653da2f6b5fbfa26c2f6b.svg";
export { ForwardRef as ReactComponent };